import type { UseFormReturn } from 'react-hook-form';

import { FormField, FormInput, FormTextarea } from '@/_components';

import { DepartmentSelect } from './components';
import type { DepartmentFormSchema } from './department-form-schema';

export function FormFields({
  form,
  isEditable = true,
  autoFocus = false,
}: {
  form: UseFormReturn<DepartmentFormSchema>;
  isEditable?: boolean;
  autoFocus?: boolean;
}) {
  const [id] = form.watch(['id']);

  return (
    <>
      <FormField
        control={form.control}
        name="name"
        render={({ field }) => (
          <FormInput
            formItemClassName="col-span-12 sm:col-span-6"
            label="Department (required)"
            {...field}
            disabled={!isEditable}
            autoFocus={autoFocus}
          />
        )}
      />

      <FormField
        control={form.control}
        name="parent"
        render={({ field }) => (
          <DepartmentSelect
            formItemClassName="col-span-12 sm:col-span-6"
            value={field.value}
            label="Parent"
            onValueChange={field.onChange}
            disabled={!isEditable}
            filterId={id}
          />
        )}
      />

      <div className="sm:col-span-12">
        <FormField
          control={form.control}
          name="description"
          render={({ field }) => <FormTextarea label="Description" {...field} disabled={!isEditable} />}
        />
      </div>
    </>
  );
}
